// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.results_toolbar__qfuoe {
  padding: 0px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 72px;
  gap: 8px;
  position: fixed;
}

.results_toolbarIconContainer__ALYja {
  display: flex;
  align-items: center;
  width: 48px;
  height: 48px;
}

.results_wrapper__NhYBR {
  padding: 72px 16px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100dvh;
}

.results_title__jGpHZ {
  width: 100%;
  font-size: 18px;
  font-weight: 700;
  line-height: 23px;
  letter-spacing: 0em;
  text-align: center;
  align-items: center;
  color: white;
}

.results_description__Oiv7N {
  color: white;
  font-size: 22px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: start;
  padding-top: 20px;
  padding-bottom: 12px;
}

.results_result__bN4OK {
  margin-top: 16px;
  font-size: 64px;
  font-weight: 700;
  line-height: 40px;
  letter-spacing: 0em;
  text-align: center;
  color: white;
}

.results_spacer__7ASBd {
  flex: 1 1;
}

.results_spinner__sUBjW {
  animation: results_spin__l\\+lL\\+ 4s linear infinite;
  margin-top: 16px;
}

.results_backButton__F0oaM {
  position: fixed;
  color: white;
  fill: white;
}

.results_input__cJXhU {
  height: 48px;
  width: 100%;
  border: 1px solid white;
  background: transparent;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: -0.0143em;
  color: white;
  padding-left: 13px;
  padding-right: 13px;
  box-sizing: border-box;
}

.results_inputWrapper__bx7fT {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.results_actionWrapper__1LTwF {
  margin-top: 24px;
  width: 100%;
}

.results_advertisementContainer__FbmRA {
  margin-top: 24px;
}

@keyframes results_spin__l\\+lL\\+ {
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/components/Results/results.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EAGE,mDAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAcA;EACE;IAEE,yBAAyB;EAC3B;AACF","sourcesContent":[".toolbar {\n  padding: 0px 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 72px;\n  gap: 8px;\n  position: fixed;\n}\n\n.toolbarIconContainer {\n  display: flex;\n  align-items: center;\n  width: 48px;\n  height: 48px;\n}\n\n.wrapper {\n  padding: 72px 16px 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: 100dvh;\n}\n\n.title {\n  width: 100%;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 23px;\n  letter-spacing: 0em;\n  text-align: center;\n  align-items: center;\n  color: white;\n}\n\n.description {\n  color: white;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 28px;\n  letter-spacing: 0em;\n  text-align: start;\n  padding-top: 20px;\n  padding-bottom: 12px;\n}\n\n.result {\n  margin-top: 16px;\n  font-size: 64px;\n  font-weight: 700;\n  line-height: 40px;\n  letter-spacing: 0em;\n  text-align: center;\n  color: white;\n}\n\n.spacer {\n  flex: 1;\n}\n\n.spinner {\n  -webkit-animation: spin 4s linear infinite;\n  -moz-animation: spin 4s linear infinite;\n  animation: spin 4s linear infinite;\n  margin-top: 16px;\n}\n\n.backButton {\n  position: fixed;\n  color: white;\n  fill: white;\n}\n\n.input {\n  height: 48px;\n  width: 100%;\n  border: 1px solid white;\n  background: transparent;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1;\n  letter-spacing: -0.0143em;\n  color: white;\n  padding-left: 13px;\n  padding-right: 13px;\n  box-sizing: border-box;\n}\n\n.inputWrapper {\n  margin-top: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n\n.actionWrapper {\n  margin-top: 24px;\n  width: 100%;\n}\n\n.advertisementContainer {\n  margin-top: 24px;\n}\n\n@-moz-keyframes spin {\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toolbar": `results_toolbar__qfuoe`,
	"toolbarIconContainer": `results_toolbarIconContainer__ALYja`,
	"wrapper": `results_wrapper__NhYBR`,
	"title": `results_title__jGpHZ`,
	"description": `results_description__Oiv7N`,
	"result": `results_result__bN4OK`,
	"spacer": `results_spacer__7ASBd`,
	"spinner": `results_spinner__sUBjW`,
	"spin": `results_spin__l+lL+`,
	"backButton": `results_backButton__F0oaM`,
	"input": `results_input__cJXhU`,
	"inputWrapper": `results_inputWrapper__bx7fT`,
	"actionWrapper": `results_actionWrapper__1LTwF`,
	"advertisementContainer": `results_advertisementContainer__FbmRA`
};
export default ___CSS_LOADER_EXPORT___;
